import Vue from 'vue';
import Vuex from 'vuex';
import state from './state';
import getters from './getters';
import mutations from './mutations';
import actions from './actions';
import debounce from 'lodash.debounce';

Vue.use(Vuex);

const store = new Vuex.Store({
    state,
    getters,
    mutations,
    actions
});

store.watch((state, getters) => {
    return getters.selectedPlatform;
}, debounce(selectedPlatform => {
    store.dispatch('resetGroups', { selectedPlatform });
    store.dispatch('resetInstruments', { platformCode: selectedPlatform.Code });
}, 100, { leading: true }));

store.watch((state, getters) => {
    return getters.selectedGroup;
}, debounce(selectedGroup => {
    store.dispatch('resetSubgroups', { selectedGroup });
    store.dispatch('resetColumns', { dataGridId: selectedGroup.DataGridId });
}, 100, { leading: true }));

store.watch((state, getters) => {
    return getters.selectedColumns;
}, (selectedColumns) => {
    if (store.state.isDataLoading) {
        return;
    }
    store.dispatch('setColumnsToShow');
});

store.watch((state, getters) => {
    return state.sortKey;
}, (sortKey) => {
    store.dispatch('resetSortIsAscending');
});

store.watch((state, getters) => {
    return [
        getters.selectedSubgroups,
        state.filter,
        state.sortKey,
        state.sortIsAscending
    ];
}, ([
    selectedSubgroups,
    filter,
    sortKey,
    sortIsAscending
]) => {
    if (store.state.isDataLoading) {
        return;
    }
    store.dispatch('setInstrumentsToShow');
});

store.watch((state, getters) => {
    return [
        getters.arePlatformsLoading,
        getters.areGroupsLoading,
        getters.areSubgroupsLoading,
        getters.areColumnsLoading,
        getters.areInstrumentsLoading
    ];
}, ([
    arePlatformsLoading,
    areGroupsLoading,
    areSubgroupsLoading,
    areColumnsLoading,
    areInstrumentsLoading
]) => {
    if (arePlatformsLoading || areGroupsLoading || areSubgroupsLoading || areColumnsLoading || areInstrumentsLoading) {
        store.commit('setIsDataLoading', { flag: true });
    } else {
        store.commit('setIsDataLoading', { flag: false });
    }
});

store.watch((state, getters) => {
    return state.isDataLoading;
}, (isDataLoading) => {
    if (isDataLoading) {
        return;
    }
    store.dispatch('setColumnsToShow');
    store.dispatch('resetSortKey');
    store.dispatch('setInstrumentsToShow');
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js